module.exports = __webpack_public_path__ + "img/4.00796b95.jpg";